import CalendarNotificationDiagnosticsStore from './schema/CalendarNotificationDiagnosticsStore';
import { createStore } from 'satcheljs';

export default createStore<CalendarNotificationDiagnosticsStore>(
    'CalendarNotificationDiagnosticsStore',
    {
        notificationUpdateLogs: [],
        selectedLogIndex: -1,
    }
);
